import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["nav"];

  connect() {
    this.body = document.querySelector("body");
  }

  toggle() {
    this.body.classList.toggle("has-open-nav");
  }

  // eslint-disable-next-line class-methods-use-this
  back() {
    window.history.back();
  }

  get nav() {
    return this.navTarget;
  }
}
